package com.exura.features.demosets.di

import com.exura.features.demosets.domain.usecase.ImportPrivateDemoSetUseCase
import com.exura.features.demosets.domain.usecase.ImportPublicDemoSetUseCase
import com.exura.features.demosets.domain.usecase.ListDemoSetsUseCase
import com.exura.features.demosets.domain.usecase.PublishPlanDefinitionUseCase
import org.koin.dsl.module

val demoSetsModule = module {
    factory<ImportPrivateDemoSetUseCase> { ImportPrivateDemoSetUseCase(get()) }
    factory<ImportPublicDemoSetUseCase> { ImportPublicDemoSetUseCase(get()) }
    factory<ListDemoSetsUseCase> { ListDemoSetsUseCase(get()) }
    factory<PublishPlanDefinitionUseCase> { PublishPlanDefinitionUseCase(get()) }
}
